// extracted by mini-css-extract-plugin
module.exports = {"companyPrimaryFilters":"JobAdsFilters_companyPrimaryFilters__hev5y","companySecondaryFilters":"JobAdsFilters_companySecondaryFilters__bdnzk"};